<template>
  <ul class="hwm-bypass">
    <li><a id="bypass-main" href="#main">{{ bypassMain }}</a></li>
    <li><a id="bypass-footer" href="#main-menu">{{ bypassFooter }}</a></li>
  </ul>
</template>
<script>
export default {
  computed: {
    appLang() {
      return this.$store.getters.getAppLang;
    },
    bypassMain() {
      return this.bypassText.main[this.appLang];
    },
    bypassFooter() {
      return this.bypassText.footer[this.appLang];
    }
  },
  data() {
    return {
      bypassText: {
        main: {
          en: 'Skip to main content',
          fr: 'Passer au contenu principal'
        },
        footer: {
          en: 'Skip to main navigation',
          fr: 'Passer à la navigation principale'
        }
      }
    };
  }
};
</script>
<style lang="scss">
  $base_font_family: Arial;
  $chwm_dark_grey: #4a4a4a;
  // ***
  .hwm-bypass {
    position:absolute;
    margin:0;
    padding:0;
    left:0;
    top:0;
    font-size:0;
    list-style:none;
    font-family:$base_font_family;
    li {margin:0;padding:0;font-size:1rem;clear:both;line-height:1.5;}
    li:last-child {margin:0;}
    a {
      color:#fff;
      padding:5px 10px;
      display:block;
      float:left;
      background:$chwm_dark_grey;
      font-size:1em;
      position:relative;
      opacity:0;
      outline-offset:-#{$focus_outline_size}px;
      z-index:-1;
      &:active, &:focus {z-index:999;opacity:1;}
    }
  }
</style>